import BomHeaderView from './bom/components/BomHeaderView';
import BomHeaderEditor from './bom/components/BomHeaderEditor';
import BomProcessEditor from './bom/components/BomProcessEditor';
import BomMaterialEditor from './bom/components/BomMaterialEditor';
import BomMetalEditor from './bom/components/BomMetalEditor';
import BomStoneEditor from './bom/components/BomStoneEditor';
import BomMaterial from './bom/components/BomMaterial';
import BomProcess from './bom/components/BomProcess'
import BomProcessAdd from './bom/components/BomProcessAdd'
import BomProcessAddRow from './bom/components/BomProcessAddRow'

import ItemHeaderEditor from './item/components/ItemHeaderEditor';
import ItemHeaderView from './item/components/ItemHeaderView';
import ListChoicesItemContentRow from "./item/components/ListChoicesItemContentRow"

import ItemQVHeader from './item/components/ItemQVHeader';

import ItemPrice from './item/components/ItemPrice';
import ItemPriceEditor from './item/components/ItemPriceEditor';
import ItemPriceRow from './item/components/ItemPriceRow';

import ItemPromo from './item/components/ItemPromo';
import ItemShorthand from './item/components/ItemShorthand';
import ItemTechEditor from './item/components/ItemTechEditor';
import ItemTechViewer from './item/components/ItemTechViewer';

import RuleHeaderEditor from './rule/components/RuleHeaderEditor'; 
import RuleHeaderViewer from './rule/components/RuleHeaderViewer';
import RuleMap from './rule/components/RuleMap';
import RuleMapEditor from './rule/components/RuleMapEditor';
import RuleMapRow from './rule/components/RuleMapRow';

import ItemGridSIHwfc from "./item/components/ItemGridSIHwfc"

import cmnViewMap from '../cmn/Index';
import ItemQVPurchase from './item/components/ItemQVPurchase';
import ItemQVSales from './item/components/ItemQVSales';
import ItemQVSIH from './item/components/ItemQVSIH';
import ItemQV from './item/components/ItemQV';
import StockCheckHeaderView from './stockCheck/components/StockCheckHeaderView';
import StockCheckHeaderEditor from './stockCheck/components/StockCheckHeaderEditor';
import StockCheckSearch from './stockCheck/components/StockCheckSearch';
import StockCheckListSystem from './stockCheck/components/StockCheckListSystem';
import StockCheckListSystemRow from './stockCheck/components/StockCheckListSystemRow';
import StockCheckListPhysical from './stockCheck/components/StockCheckListPhysical';
import StockCheckListPhysicalRow from './stockCheck/components/StockCheckListPhysicalRow';
import StockCheckListPhysicalEditor from './stockCheck/components/StockCheckListPhysicalEditor';
import ProductionStockCheckListSystem from './stockCheck/components/ProductionStockCheckListSystem';
import ProductionStockCheckListSystemRow from './stockCheck/components/ProductionStockCheckListSystemRow';
import ProductionStockCheckListPhysical from './stockCheck/components/ProductionStockCheckListPhysical';
import ProductionStockCheckListPhysicalRow from './stockCheck/components/ProductionStockCheckListPhysicalRow';
import ProductionStockCheckListPhysicalEditor from './stockCheck/components/ProductionStockCheckListPhysicalEditor';
import StockCheckListDeleteEditor from './stockCheck/components/StockCheckListDeleteEditor';


//add item related views
const itemViewMap = {
    "vBomHeaderViewer": BomHeaderView,
    "vBomHeaderEditor": BomHeaderEditor,
    "vBomItemEditor_1": BomMaterialEditor,
    "vBomItemEditor_1001": BomMetalEditor,
    "vBomItemEditor_1002": BomStoneEditor,
    "vBomProcessEditor": BomProcessEditor,
    "vBomItem": BomMaterial,
    "vBomProcess": BomProcess,
    "vBomProcessAdd": BomProcessAdd,
    "vBomProcessAddRow": BomProcessAddRow,

    "vItemHeaderEditor": ItemHeaderEditor,
    "vItemHeaderViewer": ItemHeaderView,

    "vItemQV": ItemQV,
    "vItemQVSIH": ItemQVSIH,
    "vItemQVPurchase": ItemQVPurchase,
    "vItemQVSales": ItemQVSales,
    "vItemQVHeader": ItemQVHeader,
    "vItemShorthand": ItemShorthand,
    "vItemPromo": ItemPromo,
    "vItemPriceRow": ItemPriceRow,
    "vItemPriceEditor": ItemPriceEditor,
    "vItemPrice": ItemPrice,

    "vItemTechViewer": ItemTechViewer,
    "vItemTechEditor": ItemTechEditor,

    "vItemGridSIHwfc":ItemGridSIHwfc,

    "vRuleHeaderEditor":RuleHeaderEditor,
    "vRuleHeaderViewer":RuleHeaderViewer,
    "vRuleMap":RuleMap,
    "vRuleMapEditor":RuleMapEditor,
    "vRuleMapRow":RuleMapRow,

    "vStockCheckHeaderViewer": StockCheckHeaderView,
    "vStockCheckHeaderEditor": StockCheckHeaderEditor,
    "vStockCheckSearch": StockCheckSearch,
    "vStockCheckListSystem": StockCheckListSystem,
    "vStockCheckListSystemRow": StockCheckListSystemRow,
    "vStockCheckListPhysical": StockCheckListPhysical,
    "vStockCheckListPhysicalRow": StockCheckListPhysicalRow,
    "vStockCheckListPhysicalEditor": StockCheckListPhysicalEditor,
    "vStockCheckListDeleteEditor": StockCheckListDeleteEditor,
    "vProductionStockCheckListSystem": ProductionStockCheckListSystem,
    "vProductionStockCheckListSystemRow": ProductionStockCheckListSystemRow,
    "vProductionStockCheckListPhysical": ProductionStockCheckListPhysical,
    "vProductionStockCheckListPhysicalRow": ProductionStockCheckListPhysicalRow,
    "vProductionStockCheckListPhysicalEditor": ProductionStockCheckListPhysicalEditor,
    
    "vListChoicesItemContentRow":ListChoicesItemContentRow,

    ...cmnViewMap
}


export default itemViewMap
